import { z } from 'zod';

import { practiceExamSchema } from '@/_other-pages/practice-exams/@shared';

export const practiceExamUpdateSchema = practiceExamSchema
  .omit({
    id: true,
    course_name: true,
    name: true,
    parent: true,
    is_child: true,
    price: true,
    image_url: true,
    description: true,
  })
  .extend({
    user_id: z.string().nullish(),
    // assessment_id: z.number(),
    assessment_name: z.string(),
    chapters: z.array(z.number()),
    topics: z.array(z.number()),
    question_randomization: z.boolean(),
    option_randomization: z.boolean(),
    bookmark_progress: z.boolean(),
    is_child: z.boolean(),
    parent_id: z.number(),

    allow_go_back: z.boolean(),
    show_feedback: z.boolean(),
    // showIncorrectFeedback: z.boolean(),
    show_correct_answer: z.boolean(),
    force_submitanswer_before_question_change: z.boolean(),
    usetimer: z.boolean(),
    is_sample_test: z.boolean(),
  });

export type PracticeExamUpdateSchema = z.infer<typeof practiceExamUpdateSchema>;
